export const WA_NUMBER = "6285882980133";
export const WA_NUMBER_DISPLAY = "0858 8298 0133";
export const PHONE_LINK = "tel:+6285882980133";

export const waLink = (message) =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT_MSG =
    "Halo TechFlaze, saya ingin bertanya tentang jasa pembuatan website booking untuk properti saya.";

export const WA_DEMO_MSG =
    "Halo TechFlaze, saya ingin meminta contoh tampilan website booking gratis untuk properti saya.";

export const waPackageMsg = (paket, harga) =>
    `Halo TechFlaze, saya tertarik dengan Paket ${paket} (${harga}) untuk properti saya. Mohon info lebih lanjut.`;

export const waCalculatorMsg = (paket, harga) =>
    `Halo TechFlaze, saya mencoba kalkulator paket di website dan direkomendasikan Paket ${paket} (${harga}). Mohon info lebih lanjut.`;

export const waShareLink = (text) => `https://wa.me/?text=${encodeURIComponent(text)}`;
